<span
  class="badge"
  role="status"
  [ngClass]="[
    'badge-' + variant,
    pill ? 'badge-pill' : '',
    extraClass
  ]"
  [attr.aria-label]="ariaLabel ? (ariaLabel | translate) : null"
>
  <ng-content></ng-content>
</span>
